"use strict";
var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
import {
  USED_ACCOUNTS,
  LOGIN_SUCCESS,
  LOGOUT,
  MAIN_WEBSOCKET,
  OPEN_LOGIN_MODAL,
  TOKEN_KEY,
  RESTART,
  LANGUAGE,
  SESSION_KEY,
  CLIENT,
  SUCCESS
} from "@/configuration/websocketskey";
import i18n from "@/lang";
import API from "@ym-framework/api-utils";
export class LoginService {
  // // 获取已存入账户信息
  getUsedAccountsFromLocal() {
    return __async(this, null, function* () {
      try {
        let res = yield API.get(
          `api://base.local/storages/preference/${USED_ACCOUNTS}`
        );
        return res.data.value.datas;
      } catch (error) {
        return [];
      }
    });
  }
  //获取已存入子账号信息
  getUsedSubAccountsFromLocal() {
    return __async(this, null, function* () {
      try {
        let res = yield API.get(
          `api://base.local/storages/preference/${USED_ACCOUNTS}`
        );
        return res.data.value.datas;
      } catch (error) {
        return [];
      }
    });
  }
  //获取上次登录的模式
  getLastLoginTab() {
    return __async(this, null, function* () {
      try {
        let res = yield API.get(`api://base.local/storages/preference/lastLoginTab`);
        return res.data.value.tab;
      } catch (error) {
        return "account";
      }
    });
  }
  //保存上次登录的模式
  saveLastLoginTab(tab) {
    return __async(this, null, function* () {
      try {
        yield API.put(`api://base.local/storages/preference/lastLoginTab`, {
          "tab": tab
        });
      } catch (error) {
      }
    });
  }
  // // 获取所有信息
  getAllUsedAccountsFromLocal() {
    return __async(this, null, function* () {
      try {
        let res = yield API.get(
          `api://base.local/storages/preference/${USED_ACCOUNTS}`
        );
        const { value } = res.data;
        return value;
      } catch (error) {
        return {
          datas: []
        };
      }
    });
  }
  //获取所有子账号信息、
  getAllUsedSubAccountsFromLocal() {
    return __async(this, null, function* () {
      try {
        let res = yield API.get(
          `api://base.local/storages/preference/${USED_ACCOUNTS}`
        );
        const { value } = res.data;
        return value;
      } catch (error) {
        return {
          datas: []
        };
      }
    });
  }
  // // 删除存入账户
  removeUsedAccountsFromLocal(data) {
    return __async(this, null, function* () {
      try {
        const { account } = data;
        let res = yield this.getAllUsedAccountsFromLocal();
        const targetIndex = res.datas.findIndex(
          (item) => item.account === account
        );
        res.datas.splice(targetIndex, 1);
        yield API.put(`api://base.local/storages/preference/${USED_ACCOUNTS}`, {
          last_account: res.last_account.account == data.account ? {} : res.last_account,
          datas: res.datas
        });
      } catch (error) {
        throw error;
      }
    });
  }
  //删除存入账户
  removeUsedSubAccountsFromLocal(data) {
    return __async(this, null, function* () {
      try {
        const { account } = data;
        let res = yield this.getAllUsedSubAccountsFromLocal();
        const targetIndex = res.datas.findIndex(
          (item) => item.account === account
        );
        res.datas.splice(targetIndex, 1);
        yield API.put(`api://base.local/storages/preference/${USED_ACCOUNTS}`, {
          last_account: res.last_account.account == data.account ? {} : res.last_account,
          datas: res.datas
        });
      } catch (error) {
        throw error;
      }
    });
  }
  // 保存账户
  savePwdToLocal(data) {
    return __async(this, null, function* () {
      try {
        let res = yield this.getUsedAccountsFromLocal();
        const targetIndex = res.findIndex(
          (item) => item.account === data.account
        );
        if (targetIndex !== -1) {
          res[targetIndex] = data;
        } else {
          res.push(data);
        }
        yield API.put(`api://base.local/storages/preference/${USED_ACCOUNTS}`, {
          last_account: data,
          datas: res
        });
      } catch (error) {
      }
    });
  }
  //保存子账号
  saveSubPwdToLocal(data) {
    return __async(this, null, function* () {
      try {
        let res = yield this.getUsedSubAccountsFromLocal();
        const targetIndex = res.findIndex(
          (item) => item.account === data.account
        );
        if (targetIndex !== -1) {
          res[targetIndex] = data;
        } else {
          res.push(data);
        }
        yield API.put(`api://base.local/storages/preference/${USED_ACCOUNTS}`, {
          last_account: data,
          datas: res
        });
      } catch (error) {
      }
    });
  }
  // 获取系统信息
  getDeviceOfLocal() {
    return __async(this, null, function* () {
      var _a, _b, _c, _d;
      let device = yield API.get(`api://base.local/system/devices`);
      const device_mini = device.data.machine_id;
      const device_name = (_a = device.data.host.name) != null ? _a : "DESKTOP";
      const device_info = {
        // 图形控制器
        graphics_controllers_vendo: "",
        // 图形控制器模型
        graphics_controllers_model: "",
        // 操作系统 arch
        os_arch: (_b = device.data.os.arch) != null ? _b : "",
        // cpu 提供商
        cpu_vendor: "",
        // cpu 品牌
        cpu_brand: "",
        // 操作系统
        os_release: (_c = device.data.os.name) != null ? _c : "",
        // 操作系统序列号
        os_serial: "",
        // 操作系统发行版本
        os_info_distro: (_d = device.data.os.version) != null ? _d : "",
        // 网络接口名称
        network_iface_name: "",
        // mac地址
        network_mac: "",
        // 系统内存
        mem_total: ""
      };
      if (device.status === 200) {
        return {
          device_mini,
          device_name,
          device_info
        };
      }
    });
  }
  // 存储token
  setTokenToLocal(token) {
    return __async(this, null, function* () {
      yield API.put(`api://base.local/storages/preference/${TOKEN_KEY}`, { token });
    });
  }
  // 存储session
  setSessionToLocal(session) {
    return __async(this, null, function* () {
      yield API.put(`api://base.local/storages/session/${SESSION_KEY}`, { session });
    });
  }
  // 移除 token
  removeToken() {
    return __async(this, null, function* () {
      yield API.delete(`api://base.local/storages/session/${TOKEN_KEY}`);
    });
  }
  // 移除 session
  removeSession() {
    return __async(this, null, function* () {
      yield API.delete(`api://base.local/storages/session/${SESSION_KEY}`);
    });
  }
  // 登出操作 清理local 关闭已开启的profile浏览器 发出登出请求
  logout() {
    return __async(this, null, function* () {
      yield this.removeSession();
      yield this.removeToken();
      yield this.logoutWebSocket();
      yield this.closeAllOpenedBrowsers();
    });
  }
  // 切换团队
  changeTeam(token) {
    return __async(this, null, function* () {
      yield this.removeToken();
      yield this.setTokenToLocal(token);
    });
  }
  // 获取 token
  getToken() {
    return __async(this, null, function* () {
      let res = yield API.get(`api://base.local/storages/preference/${TOKEN_KEY}`);
      return res.data.value[TOKEN_KEY];
    });
  }
  // 获取 session
  getSession() {
    return __async(this, null, function* () {
      let res = yield API.get(`api://base.local/storages/session/${SESSION_KEY}`);
      return res.data.value[SESSION_KEY];
    });
  }
  // 设置语言
  setLanguageAndRestart(language) {
    return __async(this, null, function* () {
      i18n.locale = language;
      yield API.put(`api://base.local/system/locale`, {
        locale: language
      });
      yield this.setLanguage(language);
      yield API.post(`api://base.local/system/process`, {
        command: RESTART
      });
    });
  }
  // 设置语言
  setLanguage(language) {
    return __async(this, null, function* () {
      yield API.put(`api://base.local/storages/preference/${LANGUAGE}`, {
        language
      });
    });
  }
  // 读取语言
  getLanguage() {
    return __async(this, null, function* () {
      let res = yield API.get(`api://base.local/storages/preference/${LANGUAGE}`);
      return res.data.value[LANGUAGE];
    });
  }
  // 获取当前客户端依赖
  getClientDependency() {
    return __async(this, null, function* () {
      let res = yield API.get(`api://base.local/system/client-api`);
      console.log(res);
    });
  }
  // 获取当前client
  getClient() {
    return __async(this, null, function* () {
      try {
        let res = yield API.get(`api://base.local/storages/preference/${CLIENT}`);
        return res.data.value.data;
      } catch (error) {
        return null;
      }
    });
  }
  // 关闭所有打开浏览器
  closeAllOpenedBrowsers() {
    return __async(this, null, function* () {
      yield API.delete(`api://base.local/browsers`);
    });
  }
  // 登录成功
  loginSuccess() {
    return __async(this, null, function* () {
      yield API.post(`api://base.local/websockets`, {
        model: LOGIN_SUCCESS,
        value: SUCCESS
      });
    });
  }
  // 打开登录窗体
  openLoginModal() {
    return __async(this, null, function* () {
      yield API.post(`api://base.local/websockets/${MAIN_WEBSOCKET}`, {
        model: OPEN_LOGIN_MODAL,
        value: SUCCESS
      });
    });
  }
  // 退出登录
  logoutWebSocket() {
    return __async(this, null, function* () {
      yield API.post(`api://base.local/websockets`, {
        model: LOGOUT,
        value: SUCCESS
      });
    });
  }
}
